<template>
	<page enable-flex style="background: #fff;">
		<c-form v-if="productList.length" ref="form">
			<c-form-item ref="items" label="入库明细" name="items" required>
				<template #handle>
					<span style="font-size: .26rem; color: #aaa;"><span style="color: var(--color-main)">{{productList.length}}</span>条记录</span>
				</template>
				<insert-data scan-name="扫码入库" @scan="scanHandle"></insert-data>
				<detail-card v-for="(item, i) in productList" :key="i" :index="i + 1" remove-button @remove="productList.splice(i, 1)">
					<template #title>
						<span>{{[item.brand_name, item.model_name, item.color_name, item.memory_name].filter(item => item).join(' ')}}</span>
					</template>

					<template #default>
						<c-field label="背贴码">{{item.produce_unique_code}}</c-field>
						<c-field label="当前接驳人">{{item.recipient_user_realname || '-'}}</c-field>
					</template>
				</detail-card>
			</c-form-item>
		</c-form>
		<div v-else class="scan flex-grow flex-column flex-center">
			<i class="scan-icon tf">&#xe661;</i>
			<p class="scan-message">请扫描产品背贴码-入库</p>
			<div class="scan-button flex-center" @click="scanHandle()"><i class="tf-scan"></i>开始扫码</div>
		</div>

		<template v-if="productList.length" #button>
			<c-button color="main" hollow size="form" @click="mp.navigateBack()">取消</c-button>
			<c-button class="foot-button" size="form" color="main" @click="submitHandle">确认入库</c-button>
		</template>
	</page>
</template>

<script>
	export default {
		data() {
			return {
				productList: []
			}
		},

		methods: {
			scanHandle(code) {
				new Promise(resolve => {
					if (code) {
						resolve(code);
					} else {
						this.scanCode({
							success: resolve
						});
					}
				}).then(code => {
					if (this.productList.some(item => item.produce_unique_code == code)) {
						this.$message({
							message: '该背贴码已存在'
						});
						return;
					}
					this.request({
                        url: '/productCode/access/detail',
                        data: {
                            produce_unique_code: code,
                            action_type: 4  //4=待入库
                        },
						success: data => {
							if (data.main_state != 2) {
								this.$message({
									message: '该条码当前状态无法入库'
								});
							} else {
								this.productList.push(data);
							}
						},
                        fail: (code, result, msg) => {
                            this.$message({message: msg || '操作失败，请刷新后重试', type: 'warn'});
                            return false;
                        }
					});
				});
			},

			submitHandle() {
				this.$refs.form.submit({
					url: '/product/unique_code/instorage',
					rule: {
						items: [{
							type: 'function',
							message: '请扫描入库商品',
							fun: () => {
								return this.productList.length;
							}
						}]
					},
					dataFormatter: () => {
						return {
							produce_unique_code_list: this.productList.map(item => item.produce_unique_code)
						}
					},
					success: () => {
						this.mp.redirectWeb('/success/in');
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.scan {
		gap: .28rem;

		&-icon {
			font-size: 1.08rem;
			color: #ccc;
		}

		&-message {
			font-size: .28rem;
			color: #ccc;
		}

		&-button {
			gap: .22rem;
			width: 4.8rem;
			height: .88rem;
			border-radius: .44rem;
			font-size: .36rem;
			color: #fff;
			background: linear-gradient(90deg, #3D5EFF, #0078FF);
			box-shadow: 0 .04rem .1rem 0 rgba(61,94,255,.3);

			.tf {
				font-size: .4rem;
			}
		}
	}
</style>